import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperSocialGroupJoinScanConfirmPage } from './shopper-social-group-join-scan-confirm';

@NgModule({
  declarations: [
    ShopperSocialGroupJoinScanConfirmPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperSocialGroupJoinScanConfirmPage),
    TranslateModule.forChild()
  ],
})
export class ShopperSocialGroupJoinScanConfirmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-join-scan-confirm/shopper-social-group-join-scan-confirm.module.ts